import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
} from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LosService } from "src/app/_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { MasterService } from "../../Shared/app.Masters.Service";
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
declare var $: any;

@Component({
    selector: "app-mst-partner",
    templateUrl: "./mst-partner.component.html",
    styleUrls: ["./mst-partner.component.scss"],
    standalone: false
})
export class MstPartnerComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  RequestModel: RequestModel = new RequestModel();
  dataSource: any;
  loading: boolean = false;
  AccountHeadDropdown: any[] = [];
  BranchList: any[] = [];
  displayedColumns: string[] = [
    "PartnerId",
    "Partner",
    "ContactPerson_Name",
    "Type",
    "MobileNo",
    "Partner_EmailId",
    "Address",
    "RecommendedBy",
    "Base_Branch",
    "State",
    "Edit",
    "ActiveStatus",
  ];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  PartnerList: any = [];
  partnerModel: any = {};
  currentUser: any;
  groupDropdown: any[] = [];
  IsCreateAccount: boolean = true;
  stateDropdown: any[] = [];
  districkDropdown: any[] = [];
  Ischecked: boolean = false;
  tehasilDropdown: any[] = [];
  PartnerAttachment: any = [{}];
  DocModel: any[] = [];
  today: Date = new Date();
  AllowExtension: any = constantUrl.AllowExtension;
  docBaseUrl: any = constantUrl.OthersDocUrl;
  form: FormGroup;
  GetBranchesRequestModel: RequestModel = new RequestModel();
  BranchForm: UntypedFormGroup;
  UserDropdownSettings: any = {};
  branchIDs: any[] = [];
  Branch: any;
  SelectBranchId: any = "";
  ShowFilter = true;
  UpdateBranch: any;
  userFormUpdate: UntypedFormGroup;
  branch_name: any[];
  status: any = false;
  partnerCode: any = [];
  partnerCodeInput: boolean = false;
  SalesExecutiveData: any[] = [];
  isEditMode: boolean = false;
  filteredBranchList: any[] = [];


  constructor(
    private lmsService: LmsService,
    private dataSharingService: DataSharingService,
    private dialog: DialogService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private fb: UntypedFormBuilder,
    private losService: LosService,
  ) {
    this._MasterService = MasterService;
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.form = this.fb.group({
      Branch: [null],
    });
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
      this.initAttachments(this.isEditMode);

    this.dataSharingService.HeaderTitle.next("Partner List");
    this.RequestModel.PartnerType = "";
    this.getPartnerList();
    this.Get_Acc_GroupDropdown();
    this.GetBranchDropdown();
    this.GetSalesExecutive();

    this.userFormUpdate = this.fb.group({
      UpdateBranch: [[], this.minSelectedValidator(1)],
    });

    this.UserDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: this.ShowFilter,
    };
  }

  GetSalesExecutive(): Promise<any> {
    return new Promise((resolve) => {
      if (this.SalesExecutiveData && this.SalesExecutiveData.length > 0) {
        resolve(this.SalesExecutiveData);
      } else {
        this.losService.getEmployeeDropdown({}).subscribe(
          (res: any) => {
            this.SalesExecutiveData = res;
            resolve(res);
          },
          (error) => {
            console.error("Error loading sales executives:", error);
            this.SalesExecutiveData = [];
            resolve([]);
          }
        );
      }
    });
  }
  getBranchName(branchId: number): string {
    if (!branchId) return "N/A";
    const branch = this.BranchList.find((b) => b.BranchId == branchId);
    return branch ? branch.Branch_Name : "N/A";
  }

  getEmployeeName(empId: number): string {
    if (!empId) return "N/A";
    const emp = this.SalesExecutiveData.find((e) => e.EmpId == empId);
    return emp ? emp.Emp_Name : "N/A";
  }

  minSelectedValidator(min: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value && control.value.length >= min) {
        return null;
      }
      return { minSelected: true };
    };
  }

  OnUserSelect(e) {
    this.branchIDs.push({ BranchId: Number(e.BranchId) });
      this.updateFilteredBranches();

  }

  OnUserDeSelect(e) {
    let index = this.branchIDs.findIndex(
      (item) => item.BranchId === e.BranchId
    );
    this.branchIDs.splice(index, 1);
      this.updateFilteredBranches();

  }

  OnSelectAll(_$event) {
    this.branchIDs = [];
    this.BranchList.forEach((x) => {
      this.branchIDs.push({ BranchId: x.BranchId });
    });
      this.updateFilteredBranches();

  }

  OnDeSelectAll(_$event) {
    this.branchIDs = [];
    this.filteredBranchList = [];
    this.partnerModel.BaseBranchId = '';

  }
  updateFilteredBranches() {
  const selectedIds = this.branchIDs.map(x => x.BranchId);

  this.filteredBranchList = this.BranchList.filter(branch =>
    selectedIds.includes(branch.BranchId)
  );

  // Reset Base Branch if it’s no longer valid
  if (
    this.partnerModel.BaseBranchId &&
    !selectedIds.includes(this.partnerModel.BaseBranchId)
  ) {
    this.partnerModel.BaseBranchId = '';
  }
}

  Get_Acc_GroupDropdown() {
    this.lmsService.Get_Acc_GroupDropdown({}).subscribe((res: any) => {
      this.groupDropdown = res;
    });
  }

  getPartnerList() {
    this.showSpinner = true;
    this._MasterService
      .Get_PartnerList(this.RequestModel)
      .subscribe((result: any) => {
        this.PartnerList = JSON.parse(JSON.stringify(result));
        this.dataSource = new MatTableDataSource(this.PartnerList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.showSpinner = false;
        this.get_Acc_AccountList();
        this.applyStatusFilter();
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  
exportPartnerExcel() {
  const uri = 'data:application/vnd.ms-excel;base64,';

  const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';

  const base64 = (s: string) =>
    window.btoa(unescape(encodeURIComponent(s)));

  const format = (s: string, c: any) =>
    s.replace(/{(\w+)}/g, (m, p) => c[p]);

  if (!this.dataSource?.data?.length) {
    alert('No partner data to export!');
    return;
  }

  // ❌ Exclude columns
  const excludeColumns = ['PartnerId', 'IsActive'];

  // ✅ Auto-detect columns from datasource
  const columns = Object.keys(this.dataSource.data[0])
    .filter(col => !excludeColumns.includes(col));

  let html = '';

  // Header row
  html += '<tr>';
  html += '<th style="width:40px">#</th>';
  columns.forEach(col => {
    html += `<th>${col.replace(/_/g, ' ')}</th>`;
  });
  html += '</tr>';

  // Data rows
  this.dataSource.data.forEach((row: any, index: number) => {
    html += '<tr>';
    html += `<td style="text-align:center">${index + 1}</td>`;

    columns.forEach(col => {
      const value = row[col] ?? '';
      html += `<td>${value}</td>`;
    });

    html += '</tr>';
  });

  const worksheetName = `Partner-${this.RequestModel?.PartnerType || 'List'}`;
  const ctx = { worksheet: worksheetName, table: html };

  const link = document.createElement('a');
  link.href = uri + base64(format(template, ctx));
  link.download = `${worksheetName}.xls`;
  link.click();
}


  OnClose() {
    this.partnerModel = {
      PartnerId: 0,
      LoginUserId: this.currentUser.userId,
      Partner_Type: "",
      Tehsil_Id: undefined,
      District_Id: undefined,
      Partner_State: undefined,
      Partner_AccountId: 0,
      GroupId: 0,
      BaseBranchId: "",
      Partner_EmailId: "",
      ContactPerson_Name: "",
      ContactPerson_PhoneNo: "",
      RecommendedBy: "",
    };
    this.filteredBranchList = [];
    $("#partnerModel").modal("hide");
  }

  onDeletePartner(data: any, e: any = null) {
    if (e) {
      e.stopPropagation();
    }
    this.dialog
      .openConfirmDialog(`Are you sure you want to delete?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this._MasterService
            .Delete_Partner({
              PartnerId: data.PartnerId,
              LoginUserId: this.currentUser.userId,
            })
            .subscribe((res: any) => {
              this.showSpinner = false;
              if (res[0].CODE == 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.getPartnerList();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }

  onStatusToggleChange() {
    this.applyStatusFilter();
  }

  applyStatusFilter() {
    if (!this.PartnerList) return;
    let filtered = this.PartnerList;
    if (this.status === true) {
      filtered = this.PartnerList.filter(
        (x) => x.IsActive == false || x.IsActive == "false"
      );
      this.isEditMode = false;
    } else {
      filtered = this.PartnerList.filter(
        (x) => x.IsActive == true || x.IsActive == "true"
      );
      this.isEditMode = true;
    }
    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  onTogglePartnerStatus(row: any) {
    const msg =
      row.IsActive == true || row.IsActive == "true"
        ? "deactivate"
        : "activate";
    this.dialog
      .openConfirmDialog(`Do you want to ${msg} this partner? (${row.Partner})`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (!dialogResult) return;
        this.showSpinner = true;
        this._MasterService
          .Delete_Partner({
            PartnerId: row.PartnerId,
            LoginUserId: this.currentUser.userId,
          })
          .subscribe((res: any) => {
            this.showSpinner = false;
            if (res[0].CODE == 0) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
              this.getPartnerList();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
            }
          });
      });
  }

  GetStateDropdown(): Promise<any> {
    return new Promise((resolve) => {
      this._MasterService.GetState().subscribe((res: any) => {
        this.stateDropdown = res;
        resolve(res);
      });
    });
  }
  PartnerCode_Generator() {
    return new Promise((resolve) => {
      this._MasterService.PartnerCode_Generator().subscribe((res: any) => {
        this.partnerCode = res;
        this.partnerModel.PartnerCode = this.partnerCode[0].PartnerCode;
        this.partnerCodeInput = this.partnerCode[0].Mode === "1" ? true : false;
        resolve(res);
      });
    });
  }

  GetDistrickDropdown(): Promise<any> {
    return new Promise((resolve) => {
      const stateValue =
        this.partnerModel.StateId || this.partnerModel.Partner_State;

      if (stateValue) {
        this.RequestModel.StateID = stateValue;
        this.RequestModel.StateId = stateValue;

        this._MasterService.GetDistricts(this.RequestModel).subscribe(
          (res: any) => {
            this.districkDropdown = res;
            resolve(res);
          },
          (error) => {
            console.error("Error loading districts:", error);
            this.districkDropdown = [];
            resolve([]);
          }
        );
      } else {
        this.districkDropdown = [];
        resolve([]);
      }
    });
  }

  GetTehasilDropdown(): Promise<any> {
    return new Promise((resolve) => {
      const districtValue = this.partnerModel.District_Id;

      if (districtValue) {
        this.RequestModel.DistrictId = districtValue;

        this._MasterService.GetTahsil(this.RequestModel).subscribe(
          (res: any) => {
            this.tehasilDropdown = res;
            resolve(res);
          },
          (error) => {
            console.error("Error loading tehsils:", error);
            this.tehasilDropdown = [];
            resolve([]);
          }
        );
      } else {
        this.tehasilDropdown = [];
        resolve([]);
      }
    });
  }

  GetBranchDropdown() {
    this.branchIDs = [];
    this.branch_name = [];
    this._MasterService
      .GetBranchesDropdown(this.GetBranchesRequestModel)
      .subscribe((result) => {
        this.BranchList = JSON.parse(JSON.stringify(result));
      });
  }
  initAttachments(isEdit: boolean) {
  if (isEdit) {
    // Edit → API already fills PartnerAttachment
    return;
  }

  // Register New → create empty row
  this.PartnerAttachment = [{
    Title: '',
    DocFileName: null,
    File: null
  }];
}

  onSavePartner() {
    const panCorrectFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const pan = this.partnerModel.Partner_PAN_No?.toUpperCase();
    if (pan) {
      if (!panCorrectFormat.test(pan)) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Invalid PAN Number",
          ...this.configSuccess,
        });
      return; 
    }
  }

    // this.PartnerAttachment.splice(this.PartnerAttachment.length - 1, 1);
    const attachmentForSave = this.PartnerAttachment.filter(
      a => a && a.DocFileName
    );

    this.loading = true;
    this.partnerModel.RecommendedBy = Number(this.partnerModel.RecommendedBy);
    this.partnerModel.Partner_AccountId = Number(
      this.partnerModel.Partner_AccountId
    );
    this.partnerModel.BaseBranchId = Number(this.partnerModel.BaseBranchId);
    this.partnerModel.GroupId = Number(this.partnerModel.GroupId);

    var finalBranches = [];

    if (
      this.partnerModel?.UpdateBranch &&
      Array.isArray(this.partnerModel.UpdateBranch)
    ) {
      this.partnerModel.UpdateBranch.forEach((obj: any) => {
        if (obj?.BranchId != 0 && obj?.BranchId != "0") {
          if (finalBranches.length > 0) {
            var _find = finalBranches.find((x) => x.BranchId == obj?.BranchId);
            if (!_find) {
              finalBranches.push(obj);
            }
          } else {
            finalBranches.push(obj);
          }
        }
      });
    }

    this.partnerModel.Partner_Branches = finalBranches
      .map((element) => element.BranchId)
      .join(",");

    const partnerData = {
      ...this.partnerModel,
      Partner_EmailId: this.partnerModel.Partner_EmailId || "",
      ContactPerson_Name: this.partnerModel.ContactPerson_Name || "",
      RecommendedById: this.partnerModel.RecommendedBy,
      State: this.partnerModel.Partner_State,
      District_Id: this.partnerModel.District_Id,
      Tehsil_Id: this.partnerModel.Tehsil_Id,
      BaseBranchId: this.partnerModel.BaseBranchId,
    };

    console.log(partnerData);

    this._MasterService.Save_Partner({
        JSON: JSON.stringify({
          Partner: this.dataSharingService.cleanObject(partnerData),
          Attachment: this.dataSharingService.cleanObject(attachmentForSave),
        }),
      })

      .subscribe((res: any) => {
        if (res[0].CODE == -1) {
          this.dialog
          .openDialog(res[0].MSG)
            .afterClosed().subscribe(() => {
            });
        }
        this.loading = false;
        
        if (res[0].CODE == 0) {
          this.UploadPartnerDoc(); 
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.getPartnerList();
          // this.PartnerAttachment = [];
          // this.PartnerAttachment.push({});
          this.OnClose();
        } else {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  onChangeCreateAcc(event: MatCheckboxChange) {
    this.Ischecked = event.checked;
  }
  

  fileChangeListenerAttachment(files: any, input: any) {
    if (!this.PartnerAttachment[this.PartnerAttachment.length - 1].Title) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please enter  title.",
        ...this.configSuccess,
      });
      input.value = "";
      return;
    }

    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    let _fn = _pre + "_" + sanitizedFileName;
    let _find = this.PartnerAttachment.find((obj) => {
      return obj.DocFileName == _fn;
    });

    if (_find) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Same file can not be allow again.",
        ...this.configSuccess,
      });
      input.value = "";
      return;
    }

    let Ext = sanitizedFileName.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      files.value = "";
      return;
    }

    let $this = this;
    let reader = new FileReader();
    let _data: any = {};
    this.PartnerAttachment[this.PartnerAttachment.length - 1].DocFileName =
      _pre + "_" + sanitizedFileName;
    _data.DocName = _pre + "_" + sanitizedFileName;

    reader.readAsDataURL(files[0]);
    input.value = "";
    this.PartnerAttachment.push({});
    reader.onload = function () {
      _data.DocData = reader.result.toString().split(";base64,").pop();
      $this.DocModel.push(_data);
      return;
    };
  }

  removeFileAttachment(i: any) {
    this.DocModel.splice(i, 1);
    this.PartnerAttachment.splice(i, 1);
  }

  UploadPartnerDoc() {
    this.showSpinner = true;
    for (let i = 0; i < this.DocModel.length; i++) {
      this.lmsService.UploadOthersDoc(this.DocModel[i]).subscribe(
        (res: any) => {},
        (err: any) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "File not uploaded.",
            ...this.configSuccess,
          });
        }
      );
    }
  }

  OnOpenPartnerModal(data: any, e: any = null) {
    const loadSalesData = new Promise((resolve) => {
      if (this.SalesExecutiveData && this.SalesExecutiveData.length > 0) {
        resolve(true);
      } else {
        this.GetSalesExecutive();
        this.losService.getEmployeeDropdown({}).subscribe((res: any) => {
          this.SalesExecutiveData = res;
          resolve(true);
        });
      }
    });

    if (e) {
      e.stopPropagation();
    }

    loadSalesData.then(() => {
      if (data.PartnerId) {
        this._MasterService
          .Get_PartnerDetail({ PartnerId: data.PartnerId })
          .subscribe((res: any) => {
            if (res.Item1.length > 0) {
              this.partnerModel = res.Item1[0];
              this.PartnerAttachment = res.Item2;
              this.partnerModel.LoginUserId = this.currentUser.userId;
              const stateId = this.partnerModel.StateId;
              const districtId = this.partnerModel.DistrictId;
              const tehsilId = this.partnerModel.TehsilId;
              const groupId = this.partnerModel.GroupId;
              const recommendedById = this.partnerModel.RecommendedBy;
              const BaseBranchId = this.partnerModel.BaseBranchId;
              // this.partnerModel.BaseBranchId =
              //   this.partnerModel.BaseBranchId || "";
              this.partnerModel.Partner_EmailId =
                this.partnerModel.Partner_EmailId || "";
              this.partnerModel.ContactPerson_Name =
                this.partnerModel.ContactPerson_Name || "";
              this.partnerModel.RecommendedBy = recommendedById;
              this.partnerModel.BaseBranchId = BaseBranchId;
              this.loadAllDropdowns(stateId, districtId, tehsilId, groupId);
            }
          });
      } else {
        this.partnerModel = {
          PartnerId: 0,
          LoginUserId: this.currentUser.userId,
          Partner_Type: "",
          Tehsil_Id: "",
          District_Id: "",
          State: "",
          Partner_AccountId: 0,
          GroupId: 0,
          BaseBranchId: "",
          Partner_EmailId: "",
          ContactPerson_Name: "",
          ContactPerson_PhoneNo: "",
          RecommendedBy: "",
        };
        this.PartnerCode_Generator();

        this.PartnerAttachment = [{}];
        this.GetStateDropdown().then(() => {
          $("#partnerModel").modal("show");
          $("#partnerModel").css("z-index", "1050");
        });
      }
    });
  }

  async loadAllDropdowns(
    stateId: number,
    districtId: number,
    tehsilId: number,
    groupId: number
  ) {
    try {
      await this.GetStateDropdown();
      this.partnerModel.Partner_State = stateId;
      this.partnerModel.StateId = stateId;
      await this.GetDistrickDropdown();
      this.partnerModel.District_Id = districtId;
      this.partnerModel.DistrictId = districtId;
      this.partnerModel.Tehsil_Id = tehsilId;
      this.partnerModel.TehsilId = tehsilId;
      this.partnerModel.GroupId = groupId;

      if (this.partnerModel.Partner_Branches != null) {
        var branches = this.partnerModel.Partner_Branches?.split(",");
        var arr = [];
        if (branches && branches.length > 0) {
          branches.forEach((obj: any) => {
            this.branchIDs.push({ BranchId: Number(obj) });
            arr.push(this.BranchList.filter((item) => item.BranchId == obj)[0]);
          });
        }
        this.partnerModel.UpdateBranch = arr;
      }

      this.partnerModel.Partner_AccountId = Number(
        this.partnerModel.Partner_AccountId
      );
      if (Number(this.partnerModel.Partner_AccountId) > 0) {
        this.IsCreateAccount = false;
        this.Ischecked = true;
      } else {
        this.Ischecked = false;
      }
      $("#View").modal("show");
      $("#View").css("z-index", "1050");
    } catch (error) {
      console.error("Error loading dropdowns:", error);
    }
  }

  edit() {
    $("#View").modal("hide");

    const currentPartner = { ...this.partnerModel };
    const stateId = currentPartner.StateId;
    const districtId = currentPartner.DistrictId;
    const tehsilId = currentPartner.TehsilId;
    const baseBranchId = currentPartner.BaseBranchId;

    this.partnerModel = {
      ...currentPartner,
      Partner_State: "",
      District_Id: "",
      Tehsil_Id: "",
      RecommendedBy:
        currentPartner.RecommendedById || currentPartner.RecommendedBy,
      BaseBranchId: baseBranchId,
    };
    if (this.partnerModel?.UpdateBranch?.length) {
      this.filteredBranchList = this.BranchList.filter(b =>
        this.partnerModel.UpdateBranch.some(
          (u: any) => u.BranchId === b.BranchId
        )
      );
    }

    this.GetStateDropdown()
      .then(() => {
        this.partnerModel.Partner_State = stateId;
        return this.GetDistrickDropdown();
      })
      .then(() => {
        this.partnerModel.District_Id = districtId;
        return this.GetTehasilDropdown();
      })
      .then(() => {
        this.partnerModel.Tehsil_Id = tehsilId;

        this.PartnerAttachment.push({});
        $("#partnerModel").modal("show");
        $("#partnerModel").css("z-index", "1050");
      });
    if (this.partnerModel.IsPartnerCodeAuto == 1) {
      this.partnerCodeInput = true;
    } else {
      this.partnerCodeInput = false;
    }
  }

  async loadAllDropdownsForEdit(
    stateId: number,
    districtId: number,
    tehsilId: number
  ) {
    try {
      await this.GetStateDropdown();
      this.partnerModel.Partner_State = stateId;
      await this.GetDistrickDropdown();
      this.partnerModel.District_Id = districtId;
      await this.GetTehasilDropdown();
      this.partnerModel.Tehsil_Id = tehsilId;
      this.PartnerAttachment.push({});
      $("#partnerModel").modal("show");
      $("#partnerModel").css("z-index", "1050");
    } catch (error) {
      console.error("Error loading dropdowns for edit:", error);
    }
  }

  ViewData() {
    $("#View").modal("show");
    $("#View").css("z-index", "1050");
  }

  onCloseView() {
    $("#View").modal("hide");
  }

  get_Acc_AccountList() {
    this.lmsService.Get_Account_Master({}).subscribe((res: any) => {
      this.AccountHeadDropdown = res;
    });
  }

  Get_Group() {
    const account = this.AccountHeadDropdown.find((obj: any) => {
      return obj.AccountId == this.partnerModel.Partner_AccountId;
    });
    if (account) {
      this.partnerModel.GroupId = account.GroupId;
    }
  }
}
